import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { AvatarPreview } from './Avatar.styles';
import getAvatarPath from '../../../../../../../CommonUtils/getAvatarPath';
import { Button } from '../../../../../../../CommonComponents/OPL/Button/Button';
import { AVATAR_CONTAINER_HEIGHT } from '../../ContactInfo.meta';
import { FormValues } from '../../../../MySettings.meta';

interface Props {
  avatarFilename: string;
  formBag: UseFormReturn<FormValues>;
  dropZoneOptions: DropzoneOptions;
}

export const Avatar: React.FC<Props> = ({ avatarFilename, dropZoneOptions, formBag }) => {
  const { open, getInputProps } = useDropzone(dropZoneOptions);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height={AVATAR_CONTAINER_HEIGHT}
    >
      <AvatarPreview src={getAvatarPath(avatarFilename)} />

      <input aria-label="Select Photo" {...getInputProps()} />

      <Box mt="24">
        <Button
          variant="secondary"
          onClick={() => formBag.setValue('adviserImageFilename', null, { shouldDirty: true })}
          mr="8"
        >
          Remove Photo
        </Button>

        <Button onClick={open}>Upload Photo</Button>
      </Box>
    </Box>
  );
};
